import { ReactNode } from 'react';

import BookACall from 'components/BookACall';
import JobQuote from 'components/JobQuote';
import LayoutV2 from 'components/LayoutV2';
import MobileHelpButton from 'components/MobileHelpButton';
import useBreakpoint from 'hooks/useBreakpoint';
import { usePaymentSuccessContext } from 'pages/PaymentSuccess/context';

import ProgressHeaderIndicator from './ProgressHeaderIndicator';
import ProgressSidebar from './ProgressSidebar';

export interface PaymentSuccessLayoutProps {
  children: ReactNode;
}

const PaymentSuccessLayout: React.FunctionComponent<PaymentSuccessLayoutProps> =
  function ({ children }) {
    const underBreakpoint = useBreakpoint(1024);
    const { job, jobCompanyInfo, isLoading } = usePaymentSuccessContext();
    return (
      <LayoutV2
        sidePanel={underBreakpoint ? null : <ProgressSidebar />}
        header={<ProgressHeaderIndicator />}
        footer={<MobileHelpButton />}
      >
        <div className="flex flex-col flex-1 max-w-6xl mx-auto">
          <div className="block md:hidden -mx-4 -mt-4">
            <JobQuote
              job={job}
              jobCompanyInfo={jobCompanyInfo}
              isLoading={isLoading}
              variant="compact"
            />
          </div>
          <h1 className="text-20-24-em sm:text-24-28-em md:text-32-40-em mt-4 md:mt-0">
            Your Payment Status
          </h1>
          <div className="border-b border-neutral-300 w-full my-4 md:mb-6 lg:mt-6 lg:mb-10" />
          <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-x-8">
            <div className="flex flex-col col-span-1 md:col-span-7 self-stretch">
              {children}
            </div>
            <div className="hidden md:block col-span-5">
              <div className="sticky top-24 flex flex-col gap-y-6">
                <BookACall />
                <JobQuote
                  job={job}
                  jobCompanyInfo={jobCompanyInfo}
                  isLoading={isLoading}
                  variant="collapsible"
                />
              </div>
            </div>
          </div>
        </div>
      </LayoutV2>
    );
  };

export default PaymentSuccessLayout;
